import { render, staticRenderFns } from "./toNewCard.vue?vue&type=template&id=88b88f54&"
import script from "./toNewCard.vue?vue&type=script&lang=js&"
export * from "./toNewCard.vue?vue&type=script&lang=js&"
import style0 from "./toNewCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports